module.exports = __webpack_public_path__ + "img/esfj-selected.1c78ba58.png";